/* eslint-disable no-case-declarations */
import { find, get } from 'lodash';
import { getClientConfigData } from 'src/workspace/utils';
import {
  PATH_I18N_CONFIG_CURRENCY,
  PATH_METRIC_DATA_TYPE,
  PATH_METRIC_TARGET_PROGRESS_PERCENTAGE,
  PATH_METRIC_TARGET_PROGRESS_TYPE,
  PATH_METRIC_TARGET_VALUE,
  PATH_METRIC_VALUE,
  PATH_PROGRESS_TYPE_SETTINGS,
} from '../../constant';

const parseNumberFromDataType = (actual, total, dataType) => {
  switch (dataType) {
    case 'number':
      return { actual, total };
    case 'percentage':
      return { actual: `${actual}%`, total: null };

    case 'currency':
      const config = getClientConfigData();
      const currencySymbol = get(config, PATH_I18N_CONFIG_CURRENCY, '');
      return {
        actual: `${currencySymbol}${actual}`,
        total: `${currencySymbol}${total}`,
      };

    default:
      return { actual, total };
  }
};

export const getMetricData = (metric) => {
  const dataType = get(metric, PATH_METRIC_DATA_TYPE);
  const total = get(metric, PATH_METRIC_TARGET_VALUE, 0);

  const actual = get(metric, PATH_METRIC_VALUE, 0);

  return {
    ...parseNumberFromDataType(actual, total, dataType),
  };
};

export const getMetricProgressPercent = (metric) => {
  const progressPercentage = get(
    metric,
    PATH_METRIC_TARGET_PROGRESS_PERCENTAGE,
    null,
  );
  return progressPercentage;
};

export const getMetricProgressColor = (metric) => {
  const progressType = get(metric, PATH_METRIC_TARGET_PROGRESS_TYPE, null);

  const progressTypeSettings = get(metric, PATH_PROGRESS_TYPE_SETTINGS, []);
  const progressColor =
    find(progressTypeSettings, { goal_progress_type: progressType })?.color ||
    'var(--text-default)';
  return progressColor;
};
